import { useQuery } from "react-query";
import { getActionById } from "client-api-workflow";
import type { ActionData } from "./useAllActions";

const useActionById = (id: string | undefined) => {
	return useQuery<ActionData, Error>(
		["action", id],
		async () => {
			if (!id) {
				throw new Error("Action ID is required");
			}
			console.log("Fetching action by ID:", id);
			const result = await getActionById(id);
			console.log("Action API response:", result);
			return result?.data;
		},
		{
			enabled: !!id, // Only run query if id is provided
			staleTime: 30000, // 30 seconds cache
			refetchOnWindowFocus: false,
			retry: 1,
			onError: (error) => {
				console.error("Error fetching action:", error);
			},
		}
	);
};

export default useActionById;

